export default __webpack_public_path__ + "images/assets/595ad35136fabec177ff457310027edf.svg";